import React from 'react';
import { Route } from 'react-router-dom';
import { MaintenancePage } from './MaintenancePage';

export const routes = [<Route key="0" path="/maintenance" component={MaintenancePage} />];

export const navigation = { name: 'maintenance', link: '/maintenance', icon: 'Maintenance', parent: 'BoardMembers' };
